import { useNavigate } from "react-router-dom";
import { Descriptions, Spin, message, Tabs, Button, Collapse } from "antd";
import { EntityCommonInfoModel, EntityReplaceModel } from "../../entities/common";
import { DateTimeViewer } from "..";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { memo, useCallback, useMemo } from "react";

interface IndexPageHeaderWithReplaceProps {
  title: string;
  query: Function;
  replaceMutation: Function;
  replacer: (replacerCallback: (data: EntityReplaceModel) => Promise<boolean>) => JSX.Element;
}

export const IndexPageHeaderWithReplace = memo(({ title, query, replaceMutation, replacer }: IndexPageHeaderWithReplaceProps) => {
  const navigate = useNavigate();

  const { data, isLoading, isFetching } = query();

  const [replaceRecord] = replaceMutation();

  const replace = useCallback(
    async (model: EntityReplaceModel) => {
      try {
        message.loading({
          content: "در حال جایگزینی",
          key: "replaceRecord",
          duration: 0,
        });

        await replaceRecord(model).unwrap();

        message.success({
          content: "جایگزینی رکورد با موفقیت انجام شد",
          key: "replaceRecord",
          duration: 5,
        });

        return true;
      } catch {
        message.error({
          content: "جایگزینی رکورد با خطا مواجه شد",
          key: "replaceRecord",
          duration: 5,
        });

        return false;
      }
    },
    [replaceRecord]
  );

  const info = useMemo<EntityCommonInfoModel>(
    () => ({
      totalRecords: data?.totalRecords ?? 0,
      lastCreateAt: data?.lastCreateAt ?? "",
      lastUpdateAt: data?.lastUpdateAt ?? "",
    }),
    [data]
  );

  return (
    <Collapse>
      <Collapse.Panel
        key="1"
        header={<span className="text-lg">{title}</span>}
        extra={[
          <Button key="1" type="primary" onClick={() => navigate("new")} icon={<FontAwesomeIcon className="anticon align-middle" icon={faPlus} />}>
            جدید
          </Button>,
        ]}>
        <Spin spinning={isLoading || isFetching}>
          <Tabs defaultActiveKey="1" tabPosition="top">
            <Tabs.TabPane tab="اطلاعات کلی" key="info">
              <Descriptions size="small" column={{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }}>
                <Descriptions.Item label="تعداد کل" labelStyle={{ color: "gray" }}>
                  {info.totalRecords}
                </Descriptions.Item>
                <Descriptions.Item label="آخرین اضافه" labelStyle={{ color: "gray" }}>
                  <DateTimeViewer value={info.lastCreateAt} mode="distance" />
                </Descriptions.Item>
                <Descriptions.Item label="آخرین ویرایش" labelStyle={{ color: "gray" }}>
                  <DateTimeViewer value={info.lastUpdateAt} mode="distance" />
                </Descriptions.Item>
              </Descriptions>
            </Tabs.TabPane>
            <Tabs.TabPane tab="جایگزینی" key="replace">
              {replacer(replace)}
            </Tabs.TabPane>
          </Tabs>
        </Spin>
      </Collapse.Panel>
    </Collapse>
  );
});
